import { decodeFinderName, toArray, toBoolean, toStringValue } from '@/features/charting-next/adapters/chartingAdapterUtils';

const LOGICAL_ERROR_STATUSES = new Set(['error', 'failed', 'fail', 'ko']);

export class ChartingMutationError extends Error {
    constructor(message, payload = {}) {
        super(message);
        this.name = 'ChartingMutationError';
        this.payload = payload;
    }
}

const hasLogicalMutationError = (payload = {}) => {
    if (toBoolean(payload?.error, false) || payload?.ok === false || payload?.success === false) {
        return true;
    }

    return LOGICAL_ERROR_STATUSES.has(toStringValue(payload?.status).toLowerCase());
};

const normalizeFolderTickerCount = value => {
    // A missing total is unknown, not an empty folder. Older responses omitted it.
    if (typeof value !== 'number' && (typeof value !== 'string' || !value.trim())) return null;
    const count = Number(value);
    return Number.isSafeInteger(count) && count >= 0 ? count : null;
};

export function normalizeChartingFavoriteFolders(payload = {}) {
    const folders = Array.isArray(payload?.folders) ? payload.folders : Array.isArray(payload) ? payload : [];

    return folders
        .map((item, index) => {
            if (Array.isArray(item)) {
                return {
                    id: `${toStringValue(item[0], `folder-${index}`)}-${index}`,
                    name: toStringValue(item[0]),
                    label: toStringValue(item[0]),
                    color: toStringValue(item[1], '#0ea5e9'),
                    tickerCount: normalizeFolderTickerCount(item[2])
                };
            }

            return {
                id: `${toStringValue(item?.name, `folder-${index}`)}-${index}`,
                name: toStringValue(item?.name),
                label: toStringValue(item?.label || item?.name),
                color: toStringValue(item?.color, '#0ea5e9'),
                tickerCount: normalizeFolderTickerCount(item?.tickerCount ?? item?.count)
            };
        })
        .filter((item) => item.name);
}

export function normalizeChartingSavedSearches(payload = []) {
    return toArray(payload)
        .filter((value) => toStringValue(value) && toStringValue(value) !== 'last_search')
        .map((value, index) => {
            const rawName = toStringValue(value);

            return {
                id: `${rawName}-${index}`,
                name: rawName,
                label: decodeFinderName(rawName)
            };
        });
}

export function normalizeChartingMarketSavedSearches(payload = []) {
    return toArray(payload)
        .map((record, index) => {
            const name = toStringValue(record?.name);
            return {
                id: `${name || 'search'}-${index}`,
                name,
                label: decodeFinderName(name),
                definition: record?.definition || null,
                origin: toStringValue(record?.origin, 'v1'),
                changed: record?.changed || null
            };
        })
        .filter((record) => record.name);
}

export function normalizeChartingMutationResult(payload = {}, fallbackMessage = 'La operacion se ha completado.') {
    const message = toStringValue(payload?.message || payload?.status || payload?.detail, fallbackMessage);

    if (hasLogicalMutationError(payload)) {
        throw new ChartingMutationError(message, payload);
    }

    return {
        success: true,
        message,
        raw: payload
    };
}
